export default __webpack_public_path__ + "static/media/fon-bg-bottom.d1df983d.jpg";